<template>
	<v-navigation-drawer
		app
		fixed
		right
		width="650"
		temporary
		hide-overlay
		:stateless="isFixed"
		touchless
		disable-route-watcher
		:class="['drawer-container-right', myElevation, isCalendarItem]"
		v-model.sync="openState"
		ref="rightDrawerContainer">

		<template v-if="contentComponent">
			<component :is="contentComponent" />
		</template>
		<template v-else>
			<!-- TODO: Has to be smooshed right after. Yeah, needed but can be loading swirly, etc? -->
			<div>Default Content</div>
		</template>

	</v-navigation-drawer>
</template>


<script>
	import { mapState } from 'vuex'
	import { mapFields } from 'vuex-map-fields'

	export default {
		name: 'drawer-container-right',
		
		data:() => ({
			contentComponent: null,
			mouseIsOverDrawer: false,
		}),

		computed: {
			...mapState({
				mobileDrawerRightState: state => state.ui.mobileDrawerRight.openState
			}),

			...mapFields({ 
				content: 'ui.rightDrawer.content',
				isFixed: 'ui.rightDrawer.isFixed',
				overlayOpenState: 'ui.overlayMask.openState',
			}),

			openState: {
				get() { return this.$store.state.ui.rightDrawer.openState || this.mobileDrawerRightState },
				set(val) {
					if (!val && !this.mobileDrawerRightState) { 
						this.$store.dispatch('VUEX_UI_HIDE_RIGHT_DRAWER')
					}
				}
			},

			myElevation() {
				return this.isFixed ? 'elevation-0' : 'elevation-5'
			},

			isCalendarItem() {
                return this.content && this.content.file === 'Calendar_Item_Drawer' ? 'is-calendar-item-drawer' : ''
			},

			overlayElem() {
				return this.$root.$el.querySelector('.v-overlay')
			}
		},
		
		created() {
			this.loadContent()
		},

		mounted() {
			this.initEvents()
		},

		updated() {
			this.initEvents()
		},
		
		methods: {
			loadContent() {
			    this.contentComponent = (this.content) ? this.$root.loadComponent(this.content) : null
			},

			handleMouseEnter() {
				this.mouseIsOverDrawer = true
				this.$nextTick(this.handleOverlayVisibility())
			},

			handleMouseLeave() {
				this.mouseIsOverDrawer = false
				this.$nextTick(this.handleOverlayVisibility())
			},

			handleOverlayVisibility () {
				if (this.openState) {
					this.overlayOpenState = this.mouseIsOverDrawer
				}
			},

			initEvents() {
				let me = this
				let el = this.$refs['rightDrawerContainer'].$el
				if (this.isFixed === false) {	
					el.addEventListener('mouseenter', me.handleMouseEnter)
					el.addEventListener('mouseleave', me.handleMouseLeave)
				} else {
					el.removeEventListener('mouseenter', me.handleMouseEnter)
					el.removeEventListener('mouseleave', me.handleMouseLeave)
				}
			}
		},

		watch: {
			'content': {
				deep: true,
				handler() {
                    this.loadContent()
				}
			},
			
			'openState': {
				handler(oldVal, newVal) {
					this.$nextTick(this.handleOverlayVisibility)
				}
			}
		}
	}
</script>